import { render } from "./banner.vue?vue&type=template&id=c8746a3c&scoped=true"
const script = {}

import "./banner.vue?vue&type=style&index=0&id=c8746a3c&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Library/Containers/com.tencent.xinWeChat/Data/Documents/xwechat_files/wxid_1rhhjrwiu7uq22_9030/msg/file/2026-08/ubang-copilot-agents-web-deploy-2026-08-31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8746a3c"]])

export default __exports__